export default {
	pages: [
		{ name: 'page1' }
	]
}